<template>
<div>
  <v-data-table
    :headers="headers"
    :items="classificationList"
    :options.sync="options"
    :server-items-length="totalCount"
    :loading="loading"
    :footer-props="footerProps"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            label="Search"
            color="green darken-2"
            class="mb-2 mr-2"
            single-line
            hide-details
          ></v-text-field>
        <v-spacer></v-spacer>
       
            <v-btn
              color="green darken-2"
              dark
              outlined
              elevation="2"
              class="my-2"
              @click="Dialog = true"
            >
              <v-icon>mdi-plus</v-icon>
              Create New
            </v-btn>
      </v-toolbar>
    </template>
      <template v-slot:[`item.ClassificationType`]="{ item }">
        {{ item.ClassificationType == 1 ? 'Stock' : 'Property' }}
      </template>
      <template v-slot:[`item.DateCreated`]="{ item }">
        {{ formatDate(item.DateCreated) }}
      </template>
      <template v-slot:[`item.DateUpdated`]="{ item }">
        {{ formatDate(item.DateUpdated) }}
      </template>
      <template v-slot:[`item.Actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
  </v-data-table>
        <v-dialog
          v-model="Dialog"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="subtitle-1 font-weight-bold" v-if="editItemId">Update Classification</span>
              <span class="subtitle-1 font-weight-bold" v-else>New Classification</span>
              <v-spacer></v-spacer>
              <v-btn
                    icon
                    dark
                    color="secondary2"
                    @click="cancel()"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
            </v-card-title>
              <v-form @submit.prevent ref="formRef">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <span> Classification Type: </span>
                    <v-radio-group row v-model="formData.ClassificationType">
                    <v-radio
                      label="Stock"
                      color="green darken-2"
                      value="1"
                    ></v-radio>

                    <v-radio
                      label="Property"
                      color="green darken-2"
                      value="2"
                    ></v-radio>

                    <v-radio
                      label="Semi-Expendable Property"
                      color="green darken-2"
                      value="3"
                    ></v-radio>
                  </v-radio-group>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                    dense
                     v-model="formData.ClassificationDescription"
                     :rules="[formRules.required]"
                     counter
                     maxlength="250"
                     label="Description"
                     color="green"
                    ></v-textarea>
                  </v-col>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                    dense
                     v-model="formData.Code"
                     :rules="[formRules.required]"
                     counter
                     maxlength="15"
                     color="green"
                     label="Code"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                    dense
                     v-model="formData.SemiRelatedID"
                     :rules="[formRules.required2]"
                     color="green"
                     label="Related Semi-Expendable Property classification"
                     item-text="ClassificationDescription"
                     item-value="ClassificationID"
                     :items="classification_sep"
                     v-if="formData.ClassificationType == 2"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
             </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="cancel()"
              >
                Cancel
              </v-btn>
              <v-btn v-if="!editItemId"
                color="green darken-1"
                text
                @click="save"
                :loading="isLoading"
              >
                Save
              </v-btn>
              <v-btn
              v-else
                color="red darken-1"
                text
                @click="update"
                :loading="isLoading"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <fade-away-message-component
			displayType="variation2"
			v-model="fadeAwayMessage.show" 
			:message="fadeAwayMessage.message" 
			:header="fadeAwayMessage.header" 
			:top="fadeAwayMessage.top"
			:type="fadeAwayMessage.type"
		></fade-away-message-component>
  </div>
</template>

<script>
  export default {
    data: () => ({
      searchText: '',
      editItemId: null,
      footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
      totalCount: 0,
      loading: true,
       options: {},
      fadeAwayMessage : {
			show : false,
			type : 'success',
			header : 'Successfully Saved!',
			message : '',
			top : 10
		},
      isLoading: false,
      formData: {
        ClassificationType: null,
        ClassificationDescription: null,
        Code: null,
        SemiRelatedID: null,
      },
      Dialog: false,
      classificationList: [],
      headers: [
        {
          text: 'Type',
          align: 'start',
          sortable: false,
          value: 'ClassificationType',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Description',
          align: 'start',
          sortable: false,
          value: 'ClassificationDescription',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Code',
          align: 'start',
          sortable: false,
          value: 'Code',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Created',
          align: 'start',
          sortable: false,
          value: 'DateCreated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        {
          text: 'Date Updated',
          align: 'start',
          sortable: false,
          value: 'DateUpdated',
          class: "green darken-2 white--text text-caption font-weight-bold"
        },
        { text: 'Actions', value: 'Actions', align: "center", sortable: false, class: "green darken-2 white--text text-caption font-weight-bold" },
      ],
      classification_sep: [],
    }),
    watch: {
      options: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
      searchText: {
        handler () {
         this.initialize();
        },
        deep: true,
      },
    },
    created(){
      this.getClassificationSEP();
    },
    methods: {
      cancel() {
        this.editItemId = null;
        this.$refs.formRef.reset();
        this.Dialog = false;
      },
      initialize () {
        this.loading = true
         let data = new FormData();
         if(this.options.page){
              data.append('page', this.options.page);
              data.append('itemsPerPage', this.options.itemsPerPage);
         }else{
              data.append('page', 1);
              data.append('itemsPerPage', 10);
         }
         data.append("searchText", this.searchText);
              this.axiosCall(
              '/getClassification',
              'POST',
              data
          )
          .then((res) => {
            this.loading = false
              this.classificationList = res.data.data.result;
              this.totalCount = res.data.data.total;
              if(this.totalCount <= 10){
                this.options.page = 1;
              }
          })
      },
    editItem(data) {
      this.editItemId = data.ClassificationID;
      if(data.ClassificationType == 1 && data.StockTypeID == 1){
        this.formData.ClassificationType = '1';
      }
      else if(data.ClassificationType == 2 && data.StockTypeID == null){
        this.formData.ClassificationType = '2';
      }
      else if(data.ClassificationType == 1 && data.StockTypeID == 2){
        this.formData.ClassificationType = '3';
      }
      this.formData.ClassificationDescription = data.ClassificationDescription;
      this.formData.Code = data.Code;
      this.formData.SemiRelatedID = data.SemiRelatedID ? data.SemiRelatedID : 0;
      this.Dialog = true;
		},
      save () {
         if(this.$refs.formRef.validate()){
                     this.isLoading = true;
             let data = new FormData();
              if(this.formData.ClassificationType == 1){
                data.append('ClassificationType', 1);
                data.append('StockType', 1);
              }
              else if(this.formData.ClassificationType == 2){
                data.append('ClassificationType', 2);
                data.append('StockType', '');
              }
              else if(this.formData.ClassificationType == 3){
                data.append('ClassificationType', 1);
                data.append('StockType', 2);
              }
              data.append('ClassificationDescription', this.formData.ClassificationDescription);
              data.append('Code', this.formData.Code);
              data.append('SemiRelatedID', this.formData.SemiRelatedID);
                         this.axiosCall(
                        '/classification/add',
                        'POST',
                        data
                    )
                    .then((res) => {
                        this.isLoading = false;
                        if(res.data.status) {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'success';
                        this.fadeAwayMessage.message = 'Successfully Added!';
                        this.fadeAwayMessage.header = 'System Message';
                        this.$refs.formRef.reset();
                        this.Dialog = false;
                         this.initialize();
                        }else {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'error';
                        this.fadeAwayMessage.message = 'Something went wrong try again!';
                        this.fadeAwayMessage.header = 'System Message';
                        }
                    })
         }
      },
      update () {
         if(this.$refs.formRef.validate()){
                     this.isLoading = true;
             let data = new FormData();
              data.append('ClassificationID', this.editItemId);
              if(this.formData.ClassificationType == 1){
                data.append('ClassificationType', 1);
                data.append('StockType', 1);
              }
              else if(this.formData.ClassificationType == 2){
                data.append('ClassificationType', 2);
                data.append('StockType', '');
              }
              else if(this.formData.ClassificationType == 3){
                data.append('ClassificationType', 1);
                data.append('StockType', 2);
              }
              data.append('ClassificationDescription', this.formData.ClassificationDescription);
              data.append('Code', this.formData.Code);
              data.append('SemiRelatedID', this.formData.SemiRelatedID);
                         this.axiosCall(
                        '/classification/edit',
                        'POST',
                        data
                    )
                    .then((res) => {
                        this.isLoading = false;
                        if(res.data.status) {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'success';
                        this.fadeAwayMessage.message = 'Successfully Updated!';
                        this.fadeAwayMessage.header = 'System Message';
                        this.$refs.formRef.reset();
                        this.Dialog = false;
                        this.editItemId = null;
                         this.initialize();
                        }else {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'error';
                        this.fadeAwayMessage.message = 'Something went wrong try again!';
                        this.fadeAwayMessage.header = 'System Message';
                        }
                    })
         }
      },
      getClassificationSEP() {
      this.axiosCall("/get/getClassificationByType/1/2", "GET").then((res) => {
        this.classification_sep = this.prepend({ClassificationID: 0, ClassificationDescription: 'None'},res.data.data);
      });
    },
    prepend(value, array) {
    var newArray = array.slice();
    newArray.unshift(value);
    return newArray;
    },
    }
  }
</script>